import React from "react";

const NotFound = () => {
  return (
    <div className="row">
      <div className="col-1"></div>
      <div className="col">
        <h1>Not Found</h1>
      </div>
    </div>
  );
};

export default NotFound;
